import { Toggle, Stack } from "@fluentui/react";

import styles from "./ToggleSection.module.css";

interface Props {
    label: string;
    isOn: boolean;
    onToggle: (checked: boolean) => void;
    children?: React.ReactNode;
}

export const ToggleSection = ({ label, isOn, onToggle, children }: Props) => {
    return (
        <div className={styles.section}>
            <Stack horizontal verticalAlign="center" horizontalAlign="space-between" className={styles.header}>
                <span className={styles.label}>{label}</span>
                <Toggle
                    checked={isOn}
                    onChange={(_, checked) => onToggle(!!checked)}
                    styles={{
                        root: { marginBottom: 0 },
                        container: { alignItems: "center" }
                    }}
                />
            </Stack>
            {isOn && children && <div className={styles.content}>{children}</div>}
        </div>
    );
};
